import Vue from "vue"

const focus = Vue.directive('focus', {
    inserted: function (el, binding) {
        if (el.querySelector('input')) {
            el.querySelector('input').focus()
        }
    }
})

export default { focus }


// WEBPACK FOOTER //
// ./src/directives/focus.js